import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSelector.css";

const LANGUAGES = [
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || "nl";
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const currentLang = LANGUAGES.find((l) => l.code === current) ?? LANGUAGES[0];
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const select = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="lang-dropdown" ref={ref}>
      <button
        type="button"
        className="lang-dropdown__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="lang-dropdown__label">{currentLang.label}</span>
        <span className="lang-dropdown__arrow" aria-hidden="true">
          ▾
        </span>
      </button>

      {open && (
        <ul className="lang-dropdown__menu" role="listbox">
          {LANGUAGES.map((lang) => {
            const isActive = lang.code === current;

            return (
              <li key={lang.code} role="option" aria-selected={isActive}>
                <button
                  type="button"
                  className={`lang-dropdown__option${isActive ? " lang-dropdown__option--active" : ""}`}
                  onClick={() => select(lang.code)}
                  aria-current={isActive ? "true" : undefined}
                >
                  <span>{lang.label}</span>
                  {isActive && (
                    <span className="lang-dropdown__check" aria-hidden="true">
                      ✓
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
